import { ticketMgmtModalTypes } from './ticketMgmtModalTypes';

export const ticketMgmtModalConfig = [
    {
        modalType: ticketMgmtModalTypes.TAG_MODAL,
        modalId: 'tag-modal',
        modalHeaderTextData: null
    },
    {
        modalType: ticketMgmtModalTypes.TICKET_TYPE_MODAL,
        modalId: 'ticket-type-modal',
        modalHeaderTextData: null
    },
];
